// Off-Canvas Menu
jQuery('#off-canvas').on('opened.zf.offcanvas', function(){
    jQuery('#off-canvas-close').removeClass('slide-right');
    jQuery('#off-canvas-close').addClass('slide-left');
    jQuery('#mobileMenuToggle').removeClass('fadeIn-right');
    jQuery('#mobileMenuToggle').addClass('fadeOut-left');
});

jQuery('#off-canvas').on('closed.zf.offcanvas', function(){
    jQuery('#off-canvas-close').removeClass('slide-left');
    jQuery('#off-canvas-close').addClass('slide-right');
    jQuery('#mobileMenuToggle').removeClass('fadeOut-left');
    jQuery('#mobileMenuToggle').addClass('fadeIn-right');
});

// jQuery(window).scroll(function() {    // this will work when your window scrolled.
//     var height = jQuery(window).scrollTop();  //getting the scrolling height of window
//     if(height  > 60) {
//         jQuery(".header").removeClass('transparent-header');
//         jQuery(".header").addClass('sticky-header');
//     } else{
//         jQuery(".header").removeClass('sticky-header');
//         jQuery(".header").addClass('transparent-header');
//     }
// });